<template>
  <div class="coupon-confirm-popup">
    <div class="coupon-confirm-popup-shade"></div>
    <div class="coupon-confirm-popup-content">
      <p class="coupon-confirm-popup-title">{{ languages.couponSubmitTip }}</p>
      <coupon-item
        :info="activePaytypeCouponInfo"
        :languages="languages"
      ></coupon-item>
      <div class="coupon-confirm-popup-btn-wrap">
        <div
          class="coupon-confirm-popup-cancel btn j-click-coupon-confirm-cancel"
          @click="cancel"
        >
          {{ languages.couponCancel }}
        </div>
        <div
          class="coupon-confirm-popup-confirm btn j-click-coupon-confirm-sure"
          @click="confirm"
        >
          {{ languages.couponConfirm }}
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import CouponItem from '@components/officialStore/coupon/CouponItem.vue'
export default {
  name: 'couponConfirmPopup',
  props: ['languages'],
  computed: {
    activePaytypeCouponInfo() {
      return this.$store.getters.activePaytypeCouponInfo
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    }
  },
  components: {
    CouponItem
  }
}
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';
.coupon-confirm-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .4);
  }
  &-content {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    padding: 37px 47px 49px;
    background-size: 100% 100%;
    transform: translate(-50%, -50%);
    @psetbg ('common-popup.png', true, false);
  }
  &-title {
    margin-bottom: 39px;
    text-align: center;
    font-size: 36px;
    color: var(--global-tip-popup-title);
  }
  &-btn-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    background-size: cover;
    cursor: pointer;
    font-size: 36px;
    color: var(--global-tip-popup-btn);
  }
  &-cancel {
    cursor: pointer;
    @psetbg ('cancel.png');
  }
  &-confirm {
    cursor: pointer;
    @psetbg ('confirm.png');
  }
}
@media screen and (orientation: landscape) {
  .coupon-confirm-popup {
    &-content {
      padding: 25px 32px 25px;
      @psetbg ('common-popup-hen.png', false, false);
    }
    &-title {
      margin-bottom: 19px;
      font-size: 25px;
    }
    .btn {
      width: 181px;
      height: 53px;
      line-height: 53px;
      font-size: 24px;
    }
    &-cancel {
      cursor: pointer;
      @psetbg ('cancel-hen.png');
    }
    &-confirm {
      cursor: pointer;
      @psetbg ('confirm-hen.png');
    }
  }
}

</style>
